import { PermissionCode } from "@/constants/permissions";
import { AppRoutes } from "@/constants/routes";
import { Permiso } from "@/pages/role-asignation/schema/role-assignation.schema";
import { Flex, Link } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

interface Props {
  permissions: Permiso[];
}


export const ProductionMasterView = ({ permissions }: Props) => {
  const navigate = useNavigate();

  const hasAccess = (codigo: string) =>
    permissions?.some((p) => p.codigo === codigo && p.tipoPermiso === "R");

  const canUseProductionGrains = hasAccess(PermissionCode.PRODUCTION_GRAINS);
  const canUseProductionZones = hasAccess(PermissionCode.PRODUCTION_ZONES);
  const canUseZonalGrossMargin = hasAccess(PermissionCode.ZONAL_GROSS_MARGIN);
  const canUseEstablishmentFields = hasAccess(PermissionCode.ESTABLISHMENTS_FIELDS);
  const canUseServices = hasAccess(PermissionCode.SERVICES);

  return (
    <Flex flexDir="column" paddingX={2} paddingY={1} gap="10px">

      {canUseProductionGrains && (
        <Link variant="plain" onClick={() => navigate(AppRoutes.PRODUCTION_GRAINS)}>
          Granos productivos
        </Link>
      )}
      {
        canUseEstablishmentFields && (
          <Link variant="plain" onClick={() => navigate(AppRoutes.ESTABLISHMENTS_MAIN_PAGE)}>
            Maestro de establecimientos
          </Link>
        )
      }
      {
        canUseProductionZones && (
          <Link
            variant="plain"
            onClick={() => navigate(AppRoutes.PRODUCTION_ZONES)}
          >
            Zonas productivas
          </Link>
        )
      }
      {
        canUseZonalGrossMargin && (
          <Link
            variant="plain"
            onClick={() => navigate(AppRoutes.ZONAL_GROSS_MARGINS)}
          >
            Margen bruto zonal
          </Link>
        )
      }
      {
        canUseServices && (
          <Link variant="plain" onClick={() => navigate(AppRoutes.SERVICES)}>
            Maestro de servicios
          </Link>
        )
      }
    </Flex>
  );
};